import { z } from 'zod';

export const validateInvitationCodeInputSchema = z
  .object({
    code: z.string().min(1),
  })
  .strict();

export type ValidateInvitationCodeInput = z.infer<
  typeof validateInvitationCodeInputSchema
>;

export interface ValidateInvitationCodeResponse {
  valid: boolean;
}
